import { useEffect, useRef } from "react";
import Logo from "../components/Logo";
import NavLinks from "../components/NavLinks";
import MiniProfile from "../components/MiniProfile";
import About from "../components/About";
import BreakPoints from "../BreakPoints";
import { useAuth } from "../context/AuthContext";
export default function Header({ page, mode }) {
  const headerRef = useRef(null);
  const { isAuth } = useAuth();
  const { xSmall, small } = BreakPoints();
  useEffect(() => {
    const header = headerRef.current;

    document.documentElement.style.setProperty("--header-height", `${header.offsetHeight}px`);
  }, []);
  return (
    <header className="header-container header" ref={headerRef}>
      {mode === "logo" ? (
        <Logo />
      ) : (
        <>
          <div className="logo-container d-flex align-center">
            <Logo />
          </div>

          {!xSmall && !small && <NavLinks position={"header"} page={page} />}
          <MiniProfile />
          {!xSmall && !small && !isAuth && <About />}
        </>
      )}
    </header>
  );
}
